export const SET_ALL_ROOMS = 'SET_ALL_ROOMS';
export const SET_ROOM = 'SET_ROOM';
export const SET_CLINIC_ROOMS = 'SET_CLINIC_ROOMS';

